import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, nextTick, watch } from 'vue'
import JsBarcode from 'jsbarcode'

export default /*#__PURE__*/_defineComponent({
  props: {
  SNCode: {
    type: String,
    required: true,
  },
  SnIdx: {
    type: Number,
    required: true,
  },
 
},
  setup(__props) {

const props = __props


onMounted(() => {
  nextTick(() => {
    JsBarcode('.barcode'+props.SnIdx, props.SNCode, {
      textPosition: 'top',
      displayValue: true,
      fontSize: 26,
      background: '#1989fa00',
      width: 2,
      height: 60
    });
  })

 
})
watch([() => props.SNCode,()=>props.SnIdx], ([SNCode,SnIdx]) => {
//  console.log(SNCode,"监听SNCode值");
//  console.log(SnIdx,"监听SnIdx值");
 nextTick(() => {
    JsBarcode('.barcode'+props.SnIdx, props.SNCode, {
      textPosition: 'top',
      displayValue: true,
      fontSize: 26,
      background: '#1989fa00',
      width: 2,
      height: 60
    });
  })
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass('barcode' + __props.SnIdx),
      id: "barcode"
    }, null, 2))
  ]))
}
}

})